module.exports = __webpack_public_path__ + "img/back.9d9b7e0b.png";